export const FooterSection = ({ footerEl }) => {
  const { title, tag } = footerEl;
  return (
    <div className="container footer-wrapper p-h-4">
      <h2 className="title sub-heading full-wd m-v-2">{title}</h2>
      {tag === "blogs" && (
        <div className="col-flex align-start">
          <p className="m-b-1">I've just started blogging and documenting my journey.</p>
          {footerEl.data.map(({ _id, link, title }) => (
            <a key={_id} href={link} target="_blank" className="m-v-1">
              {title}
            </a>
          ))}
        </div>
      )}
      {tag === "socials" && (
        <div className="col-flex align-start">
          {footerEl.data.map(({ _id, link, title, icon }) => (
            <a key={_id} href={link} target="_blank" className="m-v-1">
              <i className={icon}></i>
              <span className="p-l-1">{title}</span>
            </a>
          ))}
        </div>
      )}
      {tag === "connect" && (
        <div className="col-flex align-start">
          <p>If you'd like to say hi or work with me:</p>
          <a href="mailto:nehaguptang.ng@gmail.com" className="btn secondary-outline-btn m-v-2">
            <i className="fa fa-envelope" title="envelope" alt="envelope"></i>
            <span className="p-l-1">Drop an email</span>
          </a>
        </div>
      )}
    </div>
  );
};
